import styled from 'styled-components';
import { mediaBreakpointUp, getThemeProp } from '@whitelabel/helpers/style';

const StyledDivider = styled.div.attrs(() => ({ className: 'divider' }))`
  margin-bottom: 1.5rem;
  border-top: ${getThemeProp('borderStyle')};
  ${mediaBreakpointUp('md')`
         margin-bottom: 2rem;
      `}
  ${mediaBreakpointUp('lg')`
         margin-bottom: 3rem;
      `};
`;

export default StyledDivider;
